import { pageTitle } from "../PageTitle";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import aiAccounting from "./../../assets/images/banner/solutions-banner.jpg";
import { useState } from "react";

import {
  FaSearch,
  FaBalanceScale,
  FaCloudUploadAlt,
  FaChartLine,
  FaProjectDiagram,
  FaUserCog,
  FaCogs,
  FaLightbulb,
} from "react-icons/fa";

const features = [
  { icon: <FaSearch />, title: "Uncover Hidden Patterns and Insights" },
  { icon: <FaBalanceScale />, title: "Enable Smarter Decision-Making" },
  { icon: <FaCloudUploadAlt />, title: "Handle Larger Data Volumes Faster" },
  { icon: <FaChartLine />, title: "Activate Untapped Data Assets" },
  {
    icon: <FaProjectDiagram />,
    title: "Optimize Workflows and Business Processes",
  },
  { icon: <FaUserCog />, title: "Deliver Data-Driven Customer Experiences" },
  { icon: <FaCogs />, title: "Build Customer-Informed Product Strategies" },
  {
    icon: <FaLightbulb />,
    title: "Run More Intelligent Operations with Fewer Resources",
  },
];

const useCasesData = {
  Education: [
    "Student recruitment and enrollment",
    "Track progress and identify gaps",
    "Student retention and success",
    "Manage facilities and equipment",
    "Create personalized experiences for nontraditional students",
  ],

  "Financial Services": [
    "Increased customer retention and profitability",
    "Fraud detection and prevention",
    "Continuous risk management",
  ],
  Telecommunications: [
    "AI-powered personalization",
    "Employee Attrition PredictioMonetization with real-time billing",
    "Smart risk monitoring & fraud prevention",
    "The telco AI platform",
  ],
};

const AI_ML = () => {
  pageTitle("AI & ML");
  const [activeTab, setActiveTab] = useState(Object.keys(useCasesData)[0]);
  return (
    <>
      <HeaderOne></HeaderOne>
      <div className="ai-overlay-wrapper" style={{ backgroundImage: `url(${aiAccounting})` }}>
        {/* <img src={aiAccounting} alt="AI Operations" className="main" /> */}

        <div className="ai-overlay">
          <h2 className="rpa-af-title">AI & ML Services</h2>
          <p className="featuring">
            <img
              src="static/media/cloudera-partner-badge.bea6d1f0f7f1dfc2b1c8.jpg"
              alt="cloudera"
              className="feature-logo"
            />
          </p>
        </div>
      </div>

      <section className="siw-rpa-section-ai-ml">
        <div className="siw-rpa-container-data-engineering container">
          <div className="siw-rpa-content">
            <span className="siw-rpa-tag">
              Adoption of Artificial Intelligence & Machine Learning continues
              to accelerate.
            </span>

            <div className="ai-ml-text">
              <p>
                92% of organizations plan to increase their investment in AI
                over the next three years.
              </p>
              <p>
                Rapid technological advancements are making the adoption of
                advanced artificial intelligence and machine learning solutions
                more practical and accessible for businesses of all sizes.
              </p>
              <p>
                <span className="SiW">SiW</span>’s experienced data scientists
                and engineers help organizations address complex challenges and
                identify opportunities where AI/ML can enhance operational
                efficiency and decision-making.
              </p>
            </div>
          </div>

          <div className="siw-rpa-cta">
            <h4
              style={{
                textAlign: "center",
                color: "rgb(230, 233, 55)",
              }}
            >
              Let’s Build Your Data Platform<br></br>
            </h4>
            <p>
              Whether you’re modernizing your data lake, moving to the cloud, or
              enabling real-time analytics, we help you turn data into trusted,
              actionable intelligence.
            </p>
            <h4>
              Contact us at{" "}
              <a href="tel:+6590059743" style={{ color: "rgb(230, 233, 55)" }}>
                +65 9005 9743
              </a>{" "}
              to discuss your AI & ML requirements or
            </h4>
            <a href="/contact" className="siw-rpa-btn">
              <i className="bi bi-calendar-week btn-icon"></i>
              SCHEDULE A MEETING
            </a>
          </div>
        </div>
      </section>
      <section className="container">
        <h5 className="data-engineering-schedule-title">
          <span className="SiW">SiW</span> Artificial Intelligence & Machine
          Learning services include data science, model development, and
          simulation capabilities.
        </h5>

        <ul className="data-engineering-list">
          <li>
            Enhancing demand forecasting through price sensitivity and
            multi-variable analysis
          </li>
          <li>
            Applying advanced analytics to optimize business processes (explore
            our full suite of data & analytics services)
          </li>
          <li>
            Simulating and modeling organizational processes for better decision
            support
          </li>
        </ul>
      </section>
      {/* <section className="ai-ml-section">
        <div className="container">
          <h2 className="ai-ml-title text-center">
            AI & ML SERVICES DESIGNED FOR YOUR BUSINESS
          </h2>

          <p className="ai-ml-text text-justify">
            Artificial intelligence and machine learning enable organizations to
            go beyond traditional descriptive analytics by building predictive
            models and prescriptive insights that drive smarter, data-driven
            decisions.
          </p>

          <p className="ai-ml-text text-justify">
            By adopting AI and ML, businesses can streamline complex internal
            processes, accelerate growth, and gain a lasting competitive edge.
          </p>

          <h3 className="ai-ml-subtitle text-center">
            Explore <span className="SiW">SiW</span>’s complete range of AI/ML
            consulting services:
          </h3>

          <div className="ai-ml-card-wrapper d-flex flex-wrap justify-content-center gap-4">
            <div className="ai-ml-card">ARTIFICIAL INTELLIGENCE</div>
            <div className="ai-ml-card">MACHINE LEARNING</div>
            <div className="ai-ml-card">GENERATIVE AI</div>
            <div className="ai-ml-card">DATA SCIENCE & ANALYTICS</div>
            <div className="ai-ml-card">NATURAL LANGUAGE PROCESSING</div>
          </div>
        </div>
      </section> */}

      <section className="ai-ml-benefits py-4">
        <div className="container">
          <h2 className="ai-ml-benefits-title text-center mb-5">
            BENEFITS OF AI & ML <span>SOLUTIONS</span>
          </h2>

          <div className="row g-4">
            {features.map((item, index) => (
              <div className="col-lg-3 col-6" key={index}>
                <div className="ai-ml-benefits-card text-center h-100">
                  <div className="ai-ml-benefits-icon">{item.icon}</div>
                  <p className="ai-ml-benefits-text">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="ai-ml-usecases-section">
        <div className="ai-ml-uc-con">
          <div className="ai-ml-usecase-container">
            <h2 className="ai-ml-usecases-title text-center text-white mb-4">
              AI/ML USE CASES
            </h2>

            <div className="row bg-white ai-ml-usecases-card">
              <div className="col-md-4 p-0 ai-ml-usecases-left">
                {Object.keys(useCasesData).map((item) => (
                  <div
                    key={item}
                    className={`ai-ml-usecases-menu-item ${
                      activeTab === item ? "ai-ml-usecases-active" : ""
                    }`}
                    onClick={() => setActiveTab(item)}
                  >
                    {item}
                  </div>
                ))}
              </div>

              <div className="col-md-8 ai-ml-usecases-right">
                <ul className="ai-ml-usecases-list">
                  {useCasesData[activeTab]?.map((point, index) => (
                    <li key={index}>{point}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterOne></FooterOne>
    </>
  );
};

export default AI_ML;
